import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

import { formatPhoneNumber, zipDeterminer } from "@dp/common";
import { computed, makeObservable, observable, runInAction, action } from "mobx";
import BrandRules from "../../utils/BrandRules";
var DineInConfirmationModel = (_class = /*#__PURE__*/function () {
  function DineInConfirmationModel(platformUtil) {
    _classCallCheck(this, DineInConfirmationModel);

    _initializerDefineProperty(this, "_lastOrderData", _descriptor, this);

    _initializerDefineProperty(this, "_restaurantDetails", _descriptor2, this);

    _initializerDefineProperty(this, "_cartItems", _descriptor3, this);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor4, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor5, this);

    makeObservable(this);
  }

  _createClass(DineInConfirmationModel, [{
    key: "setLastOrderData",
    value: function setLastOrderData(lastOrderData) {
      this._lastOrderData = lastOrderData;
    }
  }, {
    key: "setCartItems",
    value: function setCartItems(cartItems) {
      this._cartItems = cartItems;
    }
  }, {
    key: "setAppAttributesData",
    value: function setAppAttributesData(_appAttributes) {
      var _this = this;

      runInAction(function () {
        _this._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "setSessionDetailsData",
    value: function setSessionDetailsData(_sessionDetails) {
      var _this2 = this;

      runInAction(function () {
        _this2._sessionDetails = _sessionDetails;
      });
    }
  }, {
    key: "setRestaurantDetailData",
    value: function setRestaurantDetailData(restaurantDetails) {
      var _this3 = this;

      runInAction(function () {
        _this3._restaurantDetails = restaurantDetails;
      });
    }
  }, {
    key: "formatPriceOC",
    value: function formatPriceOC(price) {
      var _BrandRules, _this$_appAttributes;

      var pricingFormat = (_BrandRules = new BrandRules((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : _this$_appAttributes.currentConceptCode)) === null || _BrandRules === void 0 ? void 0 : _BrandRules.pricingFormat();

      switch (pricingFormat) {
        case "$xx":
          return "$".concat(Number(price.toFixed(2)));

        case "$xx.xx":
          return "$".concat(price.toFixed(2));

        case "xx":
          return "".concat(Number(price.toFixed(2)));

        case "xx.xx":
          return "".concat(price.toFixed(2));

        case "s52":
          return "".concat(Number(price.toFixed(2)));

        default:
          return "$".concat(Number(price.toFixed(2)));
      }
    }
  }, {
    key: "showFormattedPrice",
    value: function showFormattedPrice(num) {
      return this.formatPriceOC(Number(num));
    }
  }, {
    key: "cartItems",
    get: function get() {
      return this._cartItems;
    }
  }, {
    key: "priceInfo",
    get: function get() {
      var _this$_lastOrderData, _order$priceInfo, _order$priceInfo2, _order$priceInfo3, _order$priceInfo4;

      var order = (_this$_lastOrderData = this._lastOrderData) === null || _this$_lastOrderData === void 0 ? void 0 : _this$_lastOrderData.order;
      return {
        tax: order === null || order === void 0 ? void 0 : (_order$priceInfo = order.priceInfo) === null || _order$priceInfo === void 0 ? void 0 : _order$priceInfo.tax,
        gratuity: order === null || order === void 0 ? void 0 : order.totalTipAmount,
        subtotal: order === null || order === void 0 ? void 0 : (_order$priceInfo2 = order.priceInfo) === null || _order$priceInfo2 === void 0 ? void 0 : _order$priceInfo2.rawSubTotal,
        orderTotal: (order === null || order === void 0 ? void 0 : (_order$priceInfo3 = order.priceInfo) === null || _order$priceInfo3 === void 0 ? void 0 : _order$priceInfo3.total) + (order === null || order === void 0 ? void 0 : order.totalTipAmount),
        couponDiscount: order === null || order === void 0 ? void 0 : (_order$priceInfo4 = order.priceInfo) === null || _order$priceInfo4 === void 0 ? void 0 : _order$priceInfo4.discountAmount
      };
    }
  }, {
    key: "userEmail",
    get: function get() {
      var _this$_lastOrderData2, _this$_lastOrderData3, _this$_lastOrderData4;

      return (_this$_lastOrderData2 = this._lastOrderData) === null || _this$_lastOrderData2 === void 0 ? void 0 : (_this$_lastOrderData3 = _this$_lastOrderData2.order) === null || _this$_lastOrderData3 === void 0 ? void 0 : (_this$_lastOrderData4 = _this$_lastOrderData3.shippingGroup) === null || _this$_lastOrderData4 === void 0 ? void 0 : _this$_lastOrderData4.emailId;
    }
  }, {
    key: "userPhoneNumber",
    get: function get() {
      var _this$_lastOrderData5, _this$_lastOrderData6;

      return formatPhoneNumber((_this$_lastOrderData5 = this._lastOrderData) === null || _this$_lastOrderData5 === void 0 ? void 0 : (_this$_lastOrderData6 = _this$_lastOrderData5.order) === null || _this$_lastOrderData6 === void 0 ? void 0 : _this$_lastOrderData6.shippingGroup.phoneNumber);
    }
  }, {
    key: "userFullName",
    get: function get() {
      var _this$_lastOrderData7, _this$_lastOrderData8, _this$_lastOrderData9, _this$_lastOrderData10, _this$_lastOrderData11, _this$_lastOrderData12;

      var firstName = (_this$_lastOrderData7 = this._lastOrderData) === null || _this$_lastOrderData7 === void 0 ? void 0 : (_this$_lastOrderData8 = _this$_lastOrderData7.order) === null || _this$_lastOrderData8 === void 0 ? void 0 : (_this$_lastOrderData9 = _this$_lastOrderData8.shippingGroup) === null || _this$_lastOrderData9 === void 0 ? void 0 : _this$_lastOrderData9.firstName;
      var lastName = (_this$_lastOrderData10 = this._lastOrderData) === null || _this$_lastOrderData10 === void 0 ? void 0 : (_this$_lastOrderData11 = _this$_lastOrderData10.order) === null || _this$_lastOrderData11 === void 0 ? void 0 : (_this$_lastOrderData12 = _this$_lastOrderData11.shippingGroup) === null || _this$_lastOrderData12 === void 0 ? void 0 : _this$_lastOrderData12.lastName;
      return firstName + " " + lastName;
    }
  }, {
    key: "userOrderId",
    get: function get() {
      var _this$_lastOrderData13, _this$_lastOrderData14;

      return (_this$_lastOrderData13 = this._lastOrderData) === null || _this$_lastOrderData13 === void 0 ? void 0 : (_this$_lastOrderData14 = _this$_lastOrderData13.order) === null || _this$_lastOrderData14 === void 0 ? void 0 : _this$_lastOrderData14.orderId;
    }
  }, {
    key: "paymentDetails",
    get: function get() {
      var _this$_lastOrderData15, _this$_lastOrderData16, _this$_lastOrderData17;

      var paymentDetails = [];
      (_this$_lastOrderData15 = this._lastOrderData) === null || _this$_lastOrderData15 === void 0 ? void 0 : (_this$_lastOrderData16 = _this$_lastOrderData15.order) === null || _this$_lastOrderData16 === void 0 ? void 0 : (_this$_lastOrderData17 = _this$_lastOrderData16.paymentGroup) === null || _this$_lastOrderData17 === void 0 ? void 0 : _this$_lastOrderData17.forEach(function (payment) {
        var _ref;

        paymentDetails.push({
          creditCardType: payment === null || payment === void 0 ? void 0 : payment.creditCardType,
          amount: (_ref = (payment === null || payment === void 0 ? void 0 : payment.amount) + (payment === null || payment === void 0 ? void 0 : payment.tipAmount) + (payment === null || payment === void 0 ? void 0 : payment.paygrpTipAmount)) !== null && _ref !== void 0 ? _ref : 0,
          paygrpTipAmount: payment === null || payment === void 0 ? void 0 : payment.paygrpTipAmount,
          tipAmount: payment === null || payment === void 0 ? void 0 : payment.tipAmount,
          paymentMethod: payment === null || payment === void 0 ? void 0 : payment.paymentMethod,
          paymentCardToken: payment === null || payment === void 0 ? void 0 : payment.paymentCardToken,
          giftCardNumber: payment === null || payment === void 0 ? void 0 : payment.giftCardNumber,
          giftCardType: payment === null || payment === void 0 ? void 0 : payment.giftCardType,
          walletType: payment === null || payment === void 0 ? void 0 : payment.walletType
        });
      });
      return paymentDetails;
    }
  }, {
    key: "preferredRestaurantId",
    get: function get() {
      var _this$_restaurantDeta;

      return (_this$_restaurantDeta = this._restaurantDetails) === null || _this$_restaurantDeta === void 0 ? void 0 : _this$_restaurantDeta.atgRestaurantId;
    }
  }, {
    key: "location",
    get: function get() {
      var _this$_lastOrderData18, _this$_lastOrderData19, _this$_lastOrderData20, _this$_lastOrderData21, _this$_lastOrderData22, _this$_lastOrderData23, _this$_lastOrderData24, _this$_lastOrderData25, _this$_lastOrderData$;

      var address = (_this$_lastOrderData18 = this._lastOrderData) === null || _this$_lastOrderData18 === void 0 ? void 0 : (_this$_lastOrderData19 = _this$_lastOrderData18.order) === null || _this$_lastOrderData19 === void 0 ? void 0 : (_this$_lastOrderData20 = _this$_lastOrderData19.restaurantAddres) === null || _this$_lastOrderData20 === void 0 ? void 0 : _this$_lastOrderData20.address;
      var zipValue = address !== null && address !== void 0 && address.zipCode ? zipDeterminer({
        zipCode: address === null || address === void 0 ? void 0 : address.zipCode,
        country: address === null || address === void 0 ? void 0 : address.country
      }) : "";
      var phoneNumber = (_this$_lastOrderData21 = this._lastOrderData) === null || _this$_lastOrderData21 === void 0 ? void 0 : (_this$_lastOrderData22 = _this$_lastOrderData21.order) === null || _this$_lastOrderData22 === void 0 ? void 0 : (_this$_lastOrderData23 = _this$_lastOrderData22.restaurantAddres) === null || _this$_lastOrderData23 === void 0 ? void 0 : (_this$_lastOrderData24 = _this$_lastOrderData23.phoneDetail) === null || _this$_lastOrderData24 === void 0 ? void 0 : (_this$_lastOrderData25 = _this$_lastOrderData24.find(function (p) {
        return p.type === "Primary";
      })) === null || _this$_lastOrderData25 === void 0 ? void 0 : _this$_lastOrderData25.phoneNumber;
      var coords = address.coordinates;
      return {
        restaurantName: (_this$_lastOrderData$ = this._lastOrderData.order) === null || _this$_lastOrderData$ === void 0 ? void 0 : _this$_lastOrderData$.restaurantName,
        address1: address.street1,
        address2: address.street2,
        city: address.city,
        state: address.stateCode,
        zip: zipValue,
        phoneNumber: formatPhoneNumber(phoneNumber),
        lat: (coords === null || coords === void 0 ? void 0 : coords.latitude) || null,
        lng: (coords === null || coords === void 0 ? void 0 : coords.longitude) || null
      };
    }
  }, {
    key: "userSpecialInstructions",
    get: function get() {
      var _this$_lastOrderData26, _this$_lastOrderData27;

      return (_this$_lastOrderData26 = this._lastOrderData) === null || _this$_lastOrderData26 === void 0 ? void 0 : (_this$_lastOrderData27 = _this$_lastOrderData26.order) === null || _this$_lastOrderData27 === void 0 ? void 0 : _this$_lastOrderData27.specialInstruction;
    }
  }, {
    key: "signUpSource",
    get: function get() {
      var _this$_appAttributes2, _this$_appAttributes3, _this$_appAttributes4, _this$_appAttributes5;

      var desktop = (_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : (_this$_appAttributes3 = _this$_appAttributes2.configs) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3["orderconf-signupsrc"];
      var mobile = (_this$_appAttributes4 = this._appAttributes) === null || _this$_appAttributes4 === void 0 ? void 0 : (_this$_appAttributes5 = _this$_appAttributes4.configs) === null || _this$_appAttributes5 === void 0 ? void 0 : _this$_appAttributes5["orderconf-m-signupsrc"];
      return {
        desktop: desktop,
        mobile: mobile
      };
    }
  }, {
    key: "secondarySignupSources",
    get: function get() {
      var _this$_appAttributes6, _this$_appAttributes7;

      var sourcesString = (_this$_appAttributes6 = this._appAttributes) === null || _this$_appAttributes6 === void 0 ? void 0 : (_this$_appAttributes7 = _this$_appAttributes6.configs) === null || _this$_appAttributes7 === void 0 ? void 0 : _this$_appAttributes7["orderconf-secondary-signup"];
      var sources = sourcesString === null || sourcesString === void 0 ? void 0 : sourcesString.split(",");

      if (sources) {
        return sources === null || sources === void 0 ? void 0 : sources.map(function (source) {
          var _source, _brandNameRegex$exec;

          source = (_source = source) === null || _source === void 0 ? void 0 : _source.replace(/["']/g, "");
          var brandNameRegex = /general-(.*)-[lL]ogo/;
          var brandName = (_brandNameRegex$exec = brandNameRegex.exec(source)) === null || _brandNameRegex$exec === void 0 ? void 0 : _brandNameRegex$exec[1];
          return {
            clubName: source,
            imageName: "".concat(brandName, "-club")
          };
        });
      }

      return [];
    }
  }]);

  return DineInConfirmationModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_lastOrderData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_restaurantDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_cartItems", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setLastOrderData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setLastOrderData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCartItems", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCartItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cartItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cartItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "priceInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "priceInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userEmail", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userEmail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userPhoneNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userPhoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userFullName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userFullName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userOrderId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userOrderId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "paymentDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "preferredRestaurantId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "preferredRestaurantId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "location", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "location"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userSpecialInstructions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userSpecialInstructions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "signUpSource", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "signUpSource"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondarySignupSources", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "secondarySignupSources"), _class.prototype)), _class);
export { DineInConfirmationModel as default };